<template>
  <div class="re-table-item-delete">
    <div class="re-table-item-delete__block--left">
      <p class="inline-block">
        {{ $t("common.selectCurrent") }}
        <span class="re-table-item-delete--active m2">{{ selectionNum }}</span>
        <template v-if="showTotal">/{{ page.total }}</template>
        {{ $t("common.term") }}
      </p>
      <rc-but-list
        class="inline-block delete-left"
        v-bind="$attrs"
        :but-data="comDeleteBut"
        v-on="$listeners"
        @confirm="deleteConfirm"
      >
        <template v-if="row.common" slot-scope="{ row }">
          <template v-if="filterProp(row)">{{ $t(`common.${row.common}`) }}</template>
          <template v-else>
            {{ $t(`common.${row.common}`) }}
            {{ page[totalOrPageSize(row)] }}
            {{ $t("common.term") }}
          </template>
        </template>
      </rc-but-list>
      <slot name="left"></slot>
    </div>
    <div class="re-table-item-delete__block--right">
      <slot name="rightL"></slot>
      <slot name="rightBut">
        <rc-but-list
          class="inline-block"
          :but-data="comDeleteButRight"
          v-bind="$attrs"
          v-on="$listeners"
          @confirm="deleteConfirm"
        >
          <template v-if="row.common" slot-scope="{ row }">{{ $t(`common.${row.common}`) }}</template>
        </rc-but-list>
      </slot>
      <slot name="rightR"></slot>
    </div>
  </div>
</template>

<script>
import RcButList from "../RcButList";
import { strFirstWith, emitFun } from "@/utils";
export default {
  name: "RcTableItemDelete",
  components: { RcButList },
  props: {
    page: {
      type: Object,
      default: () => ({})
    },
    selection: {
      type: Array,
      default: () => []
    },
    deleteButData: Array,
    deleteButDataRight: Array,
    showTotal: {
      type: Boolean,
      default: true
    },
    showCurrent: {
      type: Boolean,
      default: true
    },
    showAll: {
      type: Boolean,
      default: false
    },
    showReset: {
      type: Boolean,
      default: true
    },
    showDelete: {
      type: Boolean,
      default: true
    },
    merge: {
      type: Boolean,
      default: false
    },
    mergeRight: {
      type: Boolean,
      default: false
    },
    type: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      deleteBut: [
        {
          prop: "currentPage",
          common: "currentPageSelect",
          type: "text",
          display: !this.showCurrent || this.type.isRadio
        },
        {
          prop: "selectionAll",
          common: "selectAll",
          type: "text",
          display: !this.showAll
        },
        {
          prop: "reset",
          common: "empty",
          type: "text",
          display: !this.showReset
        }
      ],
      deleteButRight: [
        {
          prop: "delete",
          common: "deletSelectTerm",
          type: "text",
          display: !this.showDelete
        }
      ]
    };
  },
  computed: {
    selectionNum() {
      return this.selection.length;
    },
    comDeleteBut() {
      return this.mergeData();
    },
    comDeleteButRight() {
      return this.mergeData("right");
    }
  },
  methods: {
    mergeData(type = "") {
      const first = "deleteBut";
      const newType = strFirstWith(type);
      const db = this[`${first}${newType}`];
      const dbd = this[`${first}Data${newType}`];
      return this[`merge${newType}`] ? [...db, ...dbd] : dbd || db;
    },
    filterProp(row, key = "reset") {
      return row.prop === key;
    },
    totalOrPageSize(row) {
      return this.filterProp(row, "selectionAll") ? "total" : "pageSize";
    },
    deleteConfirm(item, index) {
      console.log("ssssss");
      const obj = { refs: this.$parent, name: "rcTableItemDelete" };
      emitFun({ self: this, emit: false }, { item, index }, obj);
      this.$emit("delete-confirm", { item, index }, obj);
    },
    currentPage(data, index) {
      this.$parent.refs.table.toggleAllSelection();
    },
    selectionAll(data, index) {},
    reset(data, index) {
      this.$parent.reset(data, index);
    }
  }
};
</script>

<style lang="scss" scoped>
.re-table-item-delete {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0 24px;
  margin-bottom: 8px;
  background: $scim-color-table-block;
  .re-table-item-delete__block--right {
    flex: 1;
    text-align: right;
    overflow: hidden;
  }
  .re-table-item-delete--active {
    color: $scim-color-primary;
  }
  .m2 {
    margin: 0 2px;
  }
  .pr24 {
    padding-right: 24px;
  }
  .inline-block {
    display: inline-block;
  }
  ::v-deep .rc-but-list {
    .el-button {
      margin-left: 24px;
    }
  }
}
</style>
